module.exports = __webpack_public_path__ + "img/logo-google.a39f11cb.png";